import apiSportsClubs from '@/api/sports-clubs'

const state = {
    isLoading: false,
    sportsClub: null,
    validationErrors: null,
    isSubmitting: false
}

export const mutationTypes = {
    updateSportClubsStart: '[update sportsClubs] updateSportClubsStart',
    updateSportClubsSuccess: '[update sportsClubs] updateSportClubsSuccess',
    updateSportClubsFailure: '[update sportsClubs] updateSportClubsFailure',

    getSportClubsStart: '[update sportsClubs] getSportClubsStart',
    getSportClubsSuccess: '[update sportsClubs] getSportClubsSuccess',
    getSportClubsFailure: '[update sportsClubs] getSportClubsFailure'
}

export const actionType = {
    updateSportClubs: '[update sportsClubs] updateSportClubs',
    getSportClubs: '[update sportsClubs] getSportClubs'
}

const mutations = {
    [mutationTypes.updateSportClubsStart](state) {
        state.isSubmitting = true
        state.validationErrors = null
    },

    [mutationTypes.updateSportClubsSuccess](state) {
        state.isSubmitting = false
    },

    [mutationTypes.updateSportClubsFailure](state, payload) {
        state.isSubmitting = false
        state.validationErrors = payload
    },

    [mutationTypes.getSportClubsStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },

    [mutationTypes.getSportClubsSuccess](state, payload) {
        state.isLoading = false
        state.sportsClub = payload
    },

    [mutationTypes.getSportClubsFailure](state, payload) {
        state.isLoading = false
        state.validationErrors = payload
    }
}

const actions = {
    [actionType.getSportClubs](context, {id}) {
        context.commit(mutationTypes.getSportClubsStart)
        return new Promise(resolve => {
            apiSportsClubs
                .getSportClub(id)
                .then(response => {
                    context.commit(mutationTypes.getSportClubsSuccess, response.data)
                    resolve(response.data)
                })
                .catch(result => {
                    context.commit(
                        mutationTypes.getSportClubsFailure,
                        result.response.data.errors
                    )
                })
        })
    },

    [actionType.updateSportClubs](context, sport) {
      context.commit(mutationTypes.updateSportClubsStart)
      return new Promise(resolve => {
            apiSportsClubs
                .updateSportClubs(sport)
                .then(response => {
                    context.commit(mutationTypes.updateSportClubsSuccess, response.data)
                    resolve(response.data)
                })
                .catch(result => {
                    context.commit(
                        mutationTypes.updateSportClubsFailure,
                        result.response.data.errors
                    )
                })
        })
    }
}

export default {
    state,
    mutations,
    actions
}
